export default {
  namespaced: true,
  seproban: {
    title: "seproban",
    id_alarm: "id alarme",
    path: "path",
    order: "ordem de envío",
    is_send: "enviei",
    sent_at: "enviado em",
    image: "Imagem",
    downloaded: "Baixado",
    downloaded_at: "Baixado em",
    sent_seproban: "Enviado para Seproban",
    sent_seproban_at: "Enviado para Seproban em",
    send_seproban: "Enviar para o Seproban",
    fetching_images: "Obtendo imagens...",
    capture_completed: "Captura de imagens concluída",
    uploading_images: "Enviando imagens...",
    upload_finished: "Envio de imagens concluído",
    no_images_available: "Nenhuma imagem disponível para esta câmera.",
    sending: "Enviando",
    total_images: "Total imágenes",
    generated_images: "Geradas",
    sent_images: "Enviadas",
    view_detail: "Ver detalhes",
    all_downloaded_at: "Data de download completo",
    all_sent_at: "Data de envio completo",
    image_details: "Detalhes das imagens Seproban",
    event_id: "ID do evento Seproban",
    alarm_id: "ID do alarme",
    alarm_created_at: "Data de criação do alarme",
    unit: "Unidade",
    first_download_at: "Data do primeiro download",
    last_download_at: "Data do último download",
    first_sent_at: "Data do primeiro envio",
    last_sent_at: "Data do último envio",
    send_rate: "Taxa de envio",
    images_per_second: "imagens/s",
    download_date_range: "Intervalo da data de download",
    sent_date_range: "Intervalo da data de envio",
    generating_images: "Gerando imagens...",
    download_from_date: "Fecha inicio de descarga",
    download_to_date: "Fecha fin de descarga",
    sent_from_date: "Inicio de fecha de envío",
    sent_to_date: "Fin de fecha de envío",
    references: "Referencia / # Folio"
 }
}
